var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-btn',{on:{"click":function($event){return _vm.test()}}},[_vm._v(" TEST ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }